import { Input, Select, DatePicker, message, ConfigProvider } from "antd";
import { INGREDIENT_UNITS } from "../../../constant/constants";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import {
  prepareDropdown,
  getUnitFromSelectedIngredient,
  checkNumberLimit,
} from "../../../services/inventory/inventory.service";
import CustomInputNumber from "../../CustomInputNumber";

export default function PurchaseItemInputs({ records, dropdowns }) {
  const { ingId, purchaseItems, setPurchaseItems } = records;
  const { ingredientItems, suppliersDropdown } = dropdowns || {};
  const [itemNameOptions, setItemNameOptions] = useState(prepareDropdown(ingredientItems, "name", "id") || []);
  const [itemId, setitemId] = useState("");
  const [itemQty, setItemQty] = useState('');
  const [itemUnit, setItemUnit] = useState("kg");
  const [unitPrice, setUnitPrice] = useState("");
  const [totalAmount, setTotalAmount] = useState("");
  const [carriageInwards, setCarriageInwards] = useState("");
  const [purchaseDate, setPurchaseDate] = useState("");
  const [supplier, setSupplier] = useState("");

  function onHandleItemId(val) {
    setitemId(val);
  }

  function onHandleUnit(val) {
    setItemUnit(val);
  }

  function onHandleItemQty(val) {
    setItemQty(val);
  }

  function onHandleTotalAmount(val) {
    setTotalAmount(val);
  }

  function onHandleUnitPrice(val) {
    setUnitPrice(val);
  }

  function onHandleCarriageInward(val) {
    setCarriageInwards(val);
  }

  function onHandlePurchaseDate(date, dateString) {
    setPurchaseDate(dateString);
  }

  function onHandleSupplier(val) {
    setSupplier(val);
  }

  useEffect(() => {
    const ingredientUnit = getUnitFromSelectedIngredient(ingredientItems, itemId) || "kg";
    setItemUnit(ingredientUnit);
    setTotalAmount(Number(itemQty) * Number(unitPrice));
    const currentPurchaseItem = purchaseItems.find((ing) => ing.uuid === ingId);
    currentPurchaseItem.ingredientId = itemId;
    currentPurchaseItem.quantity = itemQty;
    currentPurchaseItem.unitPrice = unitPrice;
    currentPurchaseItem.carriageInwards = carriageInwards;
    currentPurchaseItem.purchaseDate = purchaseDate;
    currentPurchaseItem.supplierId = supplier;
    setPurchaseItems([...purchaseItems]);
  }, [itemId, itemQty, unitPrice, carriageInwards, purchaseDate, supplier, ingId]);

  return (
    <ConfigProvider
      theme={{
        components: {
          Select: {
            zIndexPopup: 1,
          },
        },
      }}
    >
      <section className="flex space-x-3">
        <div className="w-[185px] h-[48px]">
          <Select
            showSearch
            value={itemId}
            name="itemId"
            style={{ width: "100%", height: "100%" }}
            onChange={onHandleItemId}
            options={itemNameOptions}
            optionFilterProp="label"
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? "").toLowerCase().localeCompare((optionB?.label ?? "").toLowerCase())
            }
          />
        </div>
        <div className="w-[82px] h-[48px]">
          <CustomInputNumber
            name="itemQty"
            value={itemQty}
            setValue={onHandleItemQty}
            placeholder={'Qty'}
            isDecimalAllowed={true}
            min={0}
            max={99999}
            inputClasses="h-full"
          />
        </div>
        <div className="w-[90px] h-[48px]">
          <Select
            disabled
            value={itemUnit}
            name="itemUnit"
            style={{ width: "100%", height: "100%" }}
            onChange={onHandleUnit}
            options={INGREDIENT_UNITS}
          />
        </div>
        <div className="w-[100px] h-[48px]">          
          <CustomInputNumber
            name="unitPrice"
            value={unitPrice}
            setValue={onHandleUnitPrice}
            placeholder={'Unit Price'}
            isDecimalAllowed={true}
            min={0}
            max={99999}
            inputClasses="h-full"
          />
        </div>
        <div className="w-[87px] h-[48px]">                   
          <CustomInputNumber
            name="totalAmount"
            value={totalAmount}
            setValue={onHandleTotalAmount}
            placeholder={'Unit Price'}
            isDecimalAllowed={true}
            min={0}
            max={99999}
            inputClasses="h-full"
            disabled={true}
          />
        </div>
        <div className="w-[120px] h-[48px]">                          
          <CustomInputNumber
            name="carriageInwards"
            value={carriageInwards}
            setValue={onHandleCarriageInward}
            placeholder={'C.I.'}
            isDecimalAllowed={true}
            min={0}
            max={99999}
            inputClasses="h-full"
          />
        </div>
        <div className="w-[126px] h-[48px]">
          <DatePicker
            className={"h-full w-full"}
            showTime={false}
            onChange={onHandlePurchaseDate}
            placeholder="Purchase Date"
            value={purchaseDate ? dayjs(purchaseDate) : null}
            // disabledDate={(current) => current && current > dayjs().endOf("day")}
            disabledDate={(current) => {
              if (!current) return false;
              const today = dayjs().endOf("day");
              const sevenDaysAgo = dayjs().subtract(6, "day").startOf("day");
              return current < sevenDaysAgo || current > today;
            }}
          />
        </div>
        <div className="w-[152px] h-[48px]">
          <Select
            value={supplier}
            name="supplier"
            style={{ width: "100%", height: "100%" }}
            onChange={onHandleSupplier}
            options={suppliersDropdown}
          />
        </div>
      </section>
    </ConfigProvider>
  );
}
